import { useState } from "react";
import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const SpeedDialFAB = ({ options, className }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOptionClick = (onClick) => {
        onClick();
        setIsOpen(false);
    };

    return (
        <div className={cn("fixed bottom-24 right-6 z-50", className)}>
            {/* Backdrop */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-background/60 backdrop-blur-sm z-40"
                    onClick={() => setIsOpen(false)}
                />
            )}

            {/* Options */}
            <div
                className={cn(
                    "absolute bottom-16 right-0 flex flex-col-reverse gap-3 items-end transition-all duration-300 z-50",
                    isOpen ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
                )}
            >
                {options.map((option, index) => (
                    <button
                        key={option.id}
                        onClick={() => handleOptionClick(option.onClick)}
                        className={cn(
                            "flex items-center gap-3 bg-card border border-border rounded-full pl-4 pr-3 py-2.5 shadow-lg",
                            "hover:bg-accent transition-all duration-200",
                            "animate-in fade-in slide-in-from-bottom-2",
                        )}
                        style={{ animationDelay: `${index * 50}ms` }}
                    >
                        <span className="text-sm font-medium text-foreground whitespace-nowrap">
                            {option.label}
                        </span>
                        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                            <option.icon className="w-5 h-5 text-primary" />
                        </div>
                    </button>
                ))}
            </div>

            {/* Main FAB Button */}
            <Button
                onClick={() => setIsOpen(!isOpen)}
                size="lg"
                className={cn(
                    "w-14 h-14 rounded-full shadow-lg z-50 relative",
                    "bg-primary hover:bg-primary/90 text-primary-foreground",
                    "transition-transform duration-200",
                    isOpen && "rotate-45"
                )}
            >
                {isOpen ? <X className="w-6 h-6 text-white" /> : <Plus className="w-6 h-6 text-white" />}
            </Button>
        </div>
    );
};

export default SpeedDialFAB;
